import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/community";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/90 shadow-sm backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6">
        <a href="#top" className="flex items-center gap-2" aria-label="腐漫网首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-heart-pulse-fill text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl font-bold tracking-wide ${
              scrolled || open ? "text-foreground-950" : "text-background-50"
            }`}
          >
            腐漫网
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                  : "text-background-100 hover:bg-background-50/20 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#contact"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-chat-smile-3-line text-base"></i>
            加入讨论
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-lg lg:hidden ${
            scrolled || open ? "text-foreground-950" : "text-background-50"
          }`}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-3 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50"
          >
            <i className="ri-chat-smile-3-line text-base"></i>
            加入讨论
          </a>
        </div>
      )}
    </header>
  );
}